module.exports = __webpack_public_path__ + "static/media/down-arrow.de7700d8.svg";